import fileSys from "../fileoprators/fileSystem";
import { isDefined } from "../shared/utils";

const fs = window.require("fs");
const http = window.require("http");
const https = window.require("https");
const path = window.require("path");
let clientpfx = fs.readFileSync(fileSys.getCfgPath("../keys/client.pfx"));
function callbackTo(obj, callback) {
  if (isDefined(callback)) {
    callback(obj);
  }
}
function uploadFileNode(filepath, opt, callback) {
  if (!fs.existsSync(filepath)) {
    callbackTo(
      {
        message: "no-file"
      },
      callback
    );
    return;
  }
  let postFile = function (fileKeyValue, req) {
    let boundaryKey = Math.random().toString(16);
    let enddata = "\r\n----" + boundaryKey + "--";
    let files = [];
    for (let idx = 0; idx < fileKeyValue.length; idx++) {
      let mimetype = "application/octet-stream";
      if (fileKeyValue[idx].urlValue.search(".mp4") >= 0) {
        mimetype = "video/mp4";
      } else if (fileKeyValue[idx].urlValue.search(".jpg") >= 0) {
        mimetype = "image/jpeg";
      } else if (fileKeyValue[idx].urlValue.search(".png") >= 0) {
        mimetype = "image/png";
      } else if (fileKeyValue[idx].urlValue.search(".spng") >= 0) {
        continue;
      }
      let content =
        "\r\n----" +
        boundaryKey +
        "\r\n" +
        "Content-Type: " +
        mimetype +
        "\r\n" +
        'Content-Disposition: form-data; name="' +
        fileKeyValue[idx].urlKey +
        '"; filename="' +
        path.basename(fileKeyValue[idx].urlValue) +
        '"\r\n' +
        "Content-Transfer-Encoding: binary\r\n\r\n";
      let contentBinary = Buffer.from(content, "utf-8");
      files.push({
        contentBinary: contentBinary,
        filePath: fileKeyValue[idx].urlValue
      });
    }
    let contentLength = 0;
    for (let idy = 0; idy < files.length; idy++) {
      let stat = fs.statSync(files[idy].filePath);
      contentLength += files[idy].contentBinary.length;
      contentLength += stat.size;
    }
    req.setHeader("Content-Type", "multipart/form-data; boundary=--" + boundaryKey);
    req.setHeader("Content-Length", contentLength + Buffer.byteLength(enddata));
    req.setHeader("x-access-token", window.token);

    // 将参数发出
    let fileindex = 0;
    let doOneFile = function () {
      req.write(files[fileindex].contentBinary.toString("utf-8"));
      let fileStream = fs.createReadStream(files[fileindex].filePath, {
        bufferSize: 4 * 1024
      });
      fileStream.pipe(req, {
        end: false
      });
      fileStream.on("end", function () {
        fileindex++;
        if (fileindex === files.length) {
          req.end(enddata);
        } else {
          doOneFile();
        }
      });
    };
    if (fileindex === files.length) {
      req.end(enddata);
    } else {
      doOneFile();
    }
  };
  let files = [
    {
      urlKey: "media[]",
      urlValue: filepath
    }
  ];
  let options = {
    host: opt.serverip,
    port: opt.serverport,
    method: "POST",
    path: "/upload"
  };

  if (opt && opt["serverssl"] === 1) {
    options.pfx = clientpfx;
    options.port = "4430";
    options.passphrase = "mw.com";
    options.rejectUnauthorized = false;
  }
  var httpOrHttps = opt["serverssl"] === 1 ? https : http;
  let req = httpOrHttps.request(options, function (res) {
    let fileinfo;
    res.on("data", function (chunk) {
      try {
        fileinfo = JSON.parse(chunk);
        if (fileinfo.message === "OK" && fileinfo && fileinfo.info.length > 0) {
          let files = fileinfo.info;
          for (let id in files) {
            if (
              files[id].originalname.indexOf("_OS.") >= 0 ||
              files[id].originalname.indexOf("EL_") >= 0 ||
              files[id].originalname.indexOf("_L") >= 0
            ) {
              files[id].eyetype = "OS";
            }
            if (
              files[id].originalname.indexOf("_OD.") >= 0 ||
              files[id].originalname.indexOf("ER_") >= 0 ||
              files[id].originalname.indexOf("_R") >= 0
            ) {
              files[id].eyetype = "OD";
            }
          }
          callbackTo({ message: "OK", file: files[0] }, callback);
        } else {
          callbackTo(
            {
              message: "failed"
            },
            callback
          );
        }
      } catch (e) {
        callbackTo(
          {
            message: "failed"
          },
          callback
        );
      }
    });
    res.on("end", function () {});
  });
  req.on("error", function (e) {
    console.log("uploadFileNode request error: ", e);
    callbackTo(
      {
        message: "failed"
      },
      callback
    );
  });
  postFile(files, req);
}
export default uploadFileNode;



// WEBPACK FOOTER //
// ./src/services/uploadFileNode.js